module.exports = __webpack_public_path__ + "static/media/sol.1126fe8b.svg";